if (!customElements.get('cl-content-video')) {
  customElements.define('cl-content-video', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const video = this.querySelector('video');
      const button = this.querySelector('.cl-content-video__play');
      const status = this.querySelector('[role="status"]');
      if (!video || !button) return;
      const options = { signal: this.abort.signal };
      button.hidden = !video.paused || video.currentTime > 0;
      video.toggleAttribute('data-playback-started', button.hidden);
      video.controls = button.hidden;
      button.addEventListener('click', async () => {
        button.disabled = true;
        status.hidden = true;
        try {
          await video.play();
        } catch {
          if (this.isConnected) { status.hidden = false; video.controls = true; }
        } finally {
          button.disabled = false;
        }
      }, options);
      video.addEventListener('play', () => { video.setAttribute('data-playback-started', ''); button.hidden = true; video.controls = true; status.hidden = true; }, options);
      video.addEventListener('ended', () => { button.hidden = false; video.controls = false; }, options);
      video.addEventListener('error', () => { button.hidden = true; video.controls = true; status.hidden = false; }, options);
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.querySelector('video')?.pause();
    }
  });
}
